<h2 class="selected-option">{{ currentOption }}</h2>
<div class="likert-wrap">
  <div class="likert-container">
    <div class="likert-wrapper" *ngFor="let option of displayOptions">
      <input
        class="likert"
        type="radio"
        name="likert"
        [checked]="option.isSelected"
        [id]="option.id"
        (change)="optionChanged(option)" />
      <label [for]="option.id" [ngClass]="{ 'option-selected': !currentOption }">
        <p class="label-text">{{ option.text }}</p>
      </label>
    </div>
  </div>
  <div class="labels">
    <!-- Added aria-hidden="true" in order to have only one text element read by screen-reader (from "label-text") -->
    <span class="label label-min" aria-hidden="true">{{ labelMin }}</span>
    <span class="label label-max" aria-hidden="true">{{ labelMax }}</span>
  </div>
</div>
